<template>
  <ListItem
    v-bind="$attrs"
    :label="resolvedLabel"
    :description="resolvedDescription"
    :selected="props.selected"
    :disabled="props.disabled"
    :clickable="props.hover"
    @click="$emit('on-click')"
  >
    <template v-if="$slots.prepend" #leftSection>
      <slot name="prepend" />
    </template>
    <template v-if="$slots.append" #rightSection>
      <slot name="append" />
    </template>
  </ListItem>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { ListItem } from '@p-utilities/vue'

defineEmits(['on-click'])

const props = defineProps<{
  title?: string | number
  description?: string | number | boolean
  disabled?: boolean
  selected?: boolean
  hover?: boolean
}>()

// DS requires `label`. Coerce legacy `title` (which may be number) to string.
const resolvedLabel = computed(() => (props.title != null ? String(props.title) : ''))

// `description` may be boolean in legacy (used as a flag). DS expects string. Filter.
const resolvedDescription = computed(() => {
  const d = props.description
  if (d === false || d === true || d == null) return undefined
  return String(d)
})
</script>
